import { ApiFilterRequest } from './api-filter-request';
import { ApiPageableRequest } from './api-pageable-request';

export class ApiFiltersRequest {
    filters: ApiFilterRequest[];
    page?: ApiPageableRequest;

    constructor(options: Omit<ApiFiltersRequest, 'toServer' | 'removeFilter'>) {
        this.filters = options.filters;
        this.page = options.page;
    }

    removeFilter(fieldFilterName: string): void {
        const index = this.filters.findIndex((f) => f.field === fieldFilterName);
        this.filters.splice(index, 1);
    }

    toServer(): {
        filters: ApiFilterRequest[];
        page?: Omit<ApiPageableRequest, 'toServer' | 'sort'>;
    } {
        if (this.page) {
            return { filters: this.filters, page: this.page.toServer() };
        }

        return { filters: this.filters };
    }
}
